export enum WhoOptionsYesNoNA
{
    Yes = 1,
    No = 2,
    Not_Applicable = 3
}
